// extracted by mini-css-extract-plugin
module.exports = {"voteButtons":"votebuttons_voteButtons__tg0YM","sourcesButton":"votebuttons_sourcesButton___r66W","open":"votebuttons_open__kVqbb","sourcesDrop":"votebuttons_sourcesDrop__ZUejj"};